import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Popper from '@material-ui/core/Popper';
import clsx from 'clsx';
import React, { useRef } from 'react';

import { useToggle } from '@/src//hooks/useToggle';
import Avatar from '@/src/components/common/Avatar/Avatar';
import Button from '@/src/components/common/Elements/Button/Button';
import Icon, { ICONS } from '@/src/components/common/Elements/Icon/Icon';
import { ReplyType } from '@/src/components/project/Inbox2/types';

const HeaderActions = ({ replyType, replyingTo, onCancel, onClickReply }) => {
  const [showPopper, toggleShowPopper] = useToggle(false);
  const anchorRef = useRef(null);

  const handleClick = (replyType) => {
    onClickReply(replyType);
    toggleShowPopper(false);
  };

  const replyUser = replyType === ReplyType.REPLY_ALL ? 'All' : replyingTo;

  const replyIcon =
    replyType === ReplyType.REPLY_ALL
      ? ICONS.replyall_icon({ className: 'tw-fill-cfo-black' })
      : ICONS.reply_icon({ className: 'tw-fill-cfo-black' });

  return (
    <div className={clsx('container--emailHeader', 'tw-flex tw-items-start')}>
      <Avatar name={`Honey Batiao`} disableTooltip={true} />
      <div
        className={clsx(
          'container--emailInfo',
          'tw-flex tw-items-center tw-justify-between',
          'tw-w-full',
          'tw-ml-[10px] tw-mt-[3px]'
        )}
      >
        <Button
          buttonRef={anchorRef}
          onClick={toggleShowPopper}
          buttonClassSettings={{ variant: 'style_unset', size: 'sm' }}
        >
          Replying to {replyUser}
          <Icon className={clsx('tw-mx-[5px]')} icon={replyIcon} />
          <Icon
            className={clsx(showPopper ? 'tw-text-cfo-blue-700' : 'tw-text-cfo-black')}
            icon={ICONS.dropdown}
          />
        </Button>

        <Popper
          open={showPopper}
          anchorEl={anchorRef.current}
          placement="bottom-start"
          style={{ zIndex: 100 }}
          disablePortal={true}
        >
          <ClickAwayListener onClickAway={toggleShowPopper.bind(null, false)}>
            <div
              className={clsx(
                'container--replyOptions',
                'tw-min-w-[167px] tw-w-full',
                'tw-bg-white tw-shadow-[3px_4px_5px_rgba(0,0,0,0.06)]',
                'tw-rounded-b-[5px] tw-border-solid tw-border-[1px] tw-border-cfo-grey-500',
                'tw-mt-[7px]'
              )}
            >
              <Button
                className={clsx(
                  'tw-w-full',
                  'tw-px-[12px] tw-py-[10px]',
                  'hover:tw-bg-cfo-blue-200',
                  replyType === ReplyType.REPLY && 'tw-bg-cfo-blue-200'
                )}
                buttonClassSettings={{ variant: 'style_unset', size: 'sm', position: 'between' }}
                onClick={handleClick.bind(null, ReplyType.REPLY)}
              >
                Reply
                <Icon icon={ICONS.reply_icon({ className: 'tw-fill-cfo-black' })} />
              </Button>

              <Button
                className={clsx(
                  'tw-w-full',
                  'tw-px-[12px] tw-py-[10px]',
                  'hover:tw-bg-cfo-blue-200',
                  replyType === ReplyType.REPLY_ALL && 'tw-bg-cfo-blue-200'
                )}
                buttonClassSettings={{ variant: 'style_unset', size: 'sm', position: 'between' }}
                onClick={handleClick.bind(null, ReplyType.REPLY_ALL)}
              >
                Reply All <Icon icon={ICONS.replyall_icon({ className: 'tw-fill-cfo-black' })} />
              </Button>
            </div>
          </ClickAwayListener>
        </Popper>

        <Button buttonClassSettings={{ variant: 'style_unset', size: 'sm' }} onClick={onCancel}>
          Cancel
          <Icon className={clsx('tw-ml-[5px]', 'tw-text-[22px]')} icon={ICONS.close} />
        </Button>
      </div>
    </div>
  );
};

export default HeaderActions;
